import { apiGet, apiPost, apiPut } from '../../framework/client';
import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { NetvisorApprovalStatus } from '../../../common/application/model/enums/NetvisorApprovalStatus';

export async function getNetvisorCustomerList(keyword?: string, changedsince?: string): Promise<any> {
    const queryParams = { keyword, changedsince };
    const response = await apiGet('/api/admin/netvisor/customerlist', queryParams);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getCustomerById(customerId: string): Promise<any> {
    const response = await apiGet(`/api/admin/netvisor/customer/${customerId}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postCustomer(customerId: string): Promise<any> {
    const response = await apiPost('/api/admin/netvisor/customer', { customerId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getSalesInvoiceList(
    begininvoicedate?: string,
    endinvoicedate?: string,
    invoicestatus?: string,
): Promise<any> {
    const queryParams = { begininvoicedate, endinvoicedate, invoicestatus };
    const response = await apiGet('/api/admin/netvisor/salesinvoicelist', queryParams);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getSalesInvoiceById(invoiceNumber: string): Promise<any> {
    const response = await apiGet(`/api/admin/netvisor/salesinvoice/${invoiceNumber}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postSalesInvoice(invoiceId: string): Promise<any> {
    const response = await apiPost('/api/admin/netvisor/salesinvoice', { invoiceId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getPurchaseInvoiceById(invoiceNumber: string, update = true): Promise<any> {
    const response = await apiGet(`/api/admin/netvisor/purchaseinvoice/${invoiceNumber}?update=${update}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getPurchaseInvoiceList(
    invoicestatus?: NetvisorApprovalStatus,
    begininvoicedate?: string,
    endinvoicedate?: string,
): Promise<any> {
    const queryParams = { begininvoicedate, endinvoicedate, invoicestatus };
    const response = await apiGet('/api/admin/netvisor/purchaseinvoicelist', queryParams);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postPurchaseInvoice(invoiceId: string): Promise<any> {
    const response = await apiPost('/api/admin/netvisor/purchaseinvoice', { invoiceId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postPurchaseInvoiceAccrualRule(invoiceId: string): Promise<any> {
    const response = await apiPost('/api/admin/netvisor/purchaseinvoiceaccrual', { invoiceId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function putPurchaseInvoice(invoiceId: string): Promise<any> {
    const response = await apiPut('/api/admin/netvisor/purchaseinvoice', { invoiceId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function getVendorById(vendorId: string): Promise<any> {
    const response = await apiGet(`/api/admin/netvisor/vendor/${vendorId}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function postVendor(vendorId: any): Promise<any> {
    const response = await apiPost('/api/admin/netvisor/vendor', { vendorId });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}

export async function validatePurchaseInvoice(invoiceId: string): Promise<boolean> {
    const response = await apiGet(`/api/admin/netvisor/purchaseinvoice/validate/${invoiceId}`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
}
